const SkeletonBar = ({
    w = 'w-full',
    h = 'h-4',
}: {
    w?: string;
    h?: string;
}) => <div className={`${w} ${h} bg-gray-200 rounded animate-pulse`} />;

export const LoadingScreen = (): JSX.Element => {
    return (
        <div className="flex min-h-screen w-full bg-pk-oparko-dark-blue">
            {/* Sidebar skeleton */}
            <div className="hidden lg:flex flex-col w-[235px] min-h-screen bg-pk-oparko-dark-blue border-r border-white/10 px-4 py-6 gap-4 flex-shrink-0">
                <div className="h-10 bg-white/10 rounded animate-pulse mb-4" />
                {Array.from({ length: 8 }).map((_, i) => (
                    <div
                        key={i}
                        className="h-8 bg-white/10 rounded animate-pulse"
                    />
                ))}
            </div>

            {/* Main content skeleton */}
            <main className="flex flex-col flex-1 overflow-hidden">
                {/* Top header */}
                <div className="h-12 bg-pk-oparko-dark-blue border-b border-white/10 px-8 flex items-center">
                    <div className="h-5 w-40 bg-white/10 rounded animate-pulse" />
                </div>

                {/* Page body */}
                <div className="flex-1 bg-gray-100 p-8 flex flex-col gap-4">
                    {/* Toolbar row */}
                    <div className="flex gap-3">
                        <SkeletonBar w="w-28" h="h-9" />
                        <SkeletonBar w="w-28" h="h-9" />
                    </div>

                    {/* Table card */}
                    <div className="bg-white rounded-2xl p-6 flex flex-col gap-3">
                        {/* Table header row */}
                        <div className="flex gap-4 pb-2 border-b border-gray-100">
                            {Array.from({ length: 6 }).map((_, i) => (
                                <SkeletonBar key={i} w="w-24" h="h-4" />
                            ))}
                        </div>
                        {/* Table rows */}
                        {Array.from({ length: 8 }).map((_, i) => (
                            <div key={i} className="flex gap-4 py-2">
                                {Array.from({ length: 6 }).map((_, j) => (
                                    <SkeletonBar key={j} w="w-24" h="h-4" />
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        </div>
    );
};

export default LoadingScreen;
